import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import PageSectionHeader from '../../../features/components/PageSectionHeader'
import RightsListActions from './RightsListActions'
import RightsListTable from './RightsListTable'
// import Checkbox from '../../../components/Form/Checkbox'

import { getRights, clearRights } from '../../../modules/actions/rights'

import { rightsListSelector } from '../../../modules/selectors/rights'
import {
  selectedPartnershipIdSelector
  // partnershipsSelector
} from '../../../modules/selectors/partnerships'
// import { selectedPartnershipRightsHolderSelfAccountSelector } from '../../../modules/selectors/app'

function PartnershipRightsList({ isAdvancedPartnership }) {
  const dispatch = useDispatch()

  const [isShowAllPartners, setIsShowAllPartners] = useState(false)
  // extra state for proper rights fetching with isShowAllPartners, which clears on partnership change
  const [allowToFetchRights, setAllowToFetchRights] = useState(true)

  const rightsList = useSelector(rightsListSelector)
  // const partnerships = useSelector(partnershipsSelector)
  // const selectedPartnershipRightsHolder = useSelector(selectedPartnershipRightsHolderSelfAccountSelector)
  const selectedPartnershipId = useSelector(selectedPartnershipIdSelector)

  // always show right list for simple partnership, and for advanced only if rights exist
  const hideRightsList = isAdvancedPartnership && !rightsList.length

  // TODO uncomment and implement full no data messages when filters are developed
  // const isSomeFilterApplied = filter !== RIGHT_FILTERS_DEFAULT || !!searchTerm
  // const isSomeFilterApplied = false

  // const noDataText = useMemo(() => {
  //   return isSomeFilterApplied ? (
  //     <div>
  //       {t("There aren't any rights that match those criteria.")}
  //       <br />
  //       {t('Try clearing or modifying your search or filter.')}
  //     </div>
  //   ) : (
  //     <div>{t('There are no rights to show.')}</div>
  //   )
  // }, [isSomeFilterApplied, t])

  // show if more than 1 partnership, and user is member of rights holder account
  // const showAllPartnersCheckbox = partnerships.length > 1 && !!selectedPartnershipRightsHolder
  //
  // const isShowAllPartnersCheckHandler = useCallback(() => {
  //   setIsShowAllPartners(!isShowAllPartners)
  //   setAllowToFetchRights(true)
  // }, [isShowAllPartners])

  // todo decide what to do with it after re-design
  // const RightFilterBlock = useMemo(
  //   () =>
  //     showAllPartnersCheckbox && (
  //       <Checkbox
  //         id="checkbox_show_all_rights"
  //         title="Show for all partners"
  //         className={classes.showAllRightsCheckbox}
  //         checked={isShowAllPartners}
  //         onCheck={isShowAllPartnersCheckHandler}
  //         titleColor="black"
  //       />
  //     ),
  //   [classes.showAllRightsCheckbox, isShowAllPartners, isShowAllPartnersCheckHandler, showAllPartnersCheckbox]
  // )

  // when change partnership, reset checked state
  useEffect(() => {
    setIsShowAllPartners(false)
    setAllowToFetchRights(true)
  }, [selectedPartnershipId])

  useEffect(() => {
    if (isShowAllPartners && allowToFetchRights) {
      dispatch(getRights())

      setAllowToFetchRights(false)
    } else if (!isShowAllPartners && selectedPartnershipId && allowToFetchRights) {
      dispatch(getRights({ partnership: selectedPartnershipId }))

      setAllowToFetchRights(false)
    }
  }, [dispatch, isShowAllPartners, allowToFetchRights, selectedPartnershipId])

  useEffect(
    () => () => {
      dispatch(clearRights())
    },
    [dispatch]
  )

  if (hideRightsList) {
    return null
  }

  return (
    <>
      <PageSectionHeader
        title={isAdvancedPartnership ? 'List of Campaigns and Social Reports' : 'List of Rights'}
        RightPanel={<RightsListActions rightsList={rightsList} isAdvancedPartnership={isAdvancedPartnership} />}
      />
      <RightsListTable />
    </>
  )
}

PartnershipRightsList.propTypes = {
  isAdvancedPartnership: PropTypes.bool
}

export default PartnershipRightsList
